import { Box, Typography } from '@mui/material'
import { GridToolbarExport, GridToolbarQuickFilter } from '@mui/x-data-grid'

interface CustomToolbarProps {
  selectedRows: number
}

const CustomToolbar = ({ selectedRows }: CustomToolbarProps) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', p: 2, alignItems: 'center' }}>
      <Box>
        {selectedRows > 0 && (
          <Typography
            variant="h6"
            sx={{
              color: '#FC3E6F',
              fontWeight: 'bold'
            }}
          >
            {selectedRows} {selectedRows === 1 ? 'Seleccionado' : 'Seleccionados'}
          </Typography>
        )}
      </Box>
      <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', justifyContent: 'flex-end' }}>
        <GridToolbarQuickFilter
          sx={{
            verticalAlign: 'middle',
            marginBottom: 0,
            paddingBottom: 0
          }}
        />
        {selectedRows === 0 && (
          <GridToolbarExport
            sx={{
              '&.MuiButton-root': {
                backgroundColor: '#FC3E6F',
                color: 'white',
                minWidth: 'auto',
                padding: '6px 16px',
                '&:hover': {
                  backgroundColor: '#e53958'
                }
              }
            }}
          />
        )}
      </Box>
    </Box>
  )
}

export default CustomToolbar
